var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({height:_vm.height+'px',zIndex:_vm.zIndex})},[_c('div',{class:_vm.className,style:({backgroundColor:_vm.backgroundColor,top:_vm.stickyTop+'px',zIndex:_vm.zIndex,position:_vm.position,width:_vm.width,height:_vm.height+'px'})},[_vm._t("default",function(){return [_c('div',[_vm._v("sticky")])]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0dabc0f4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sticky/index.vue
// module id = null
// module chunks = 